import { connect } from 'react-redux';
import { toggleBundlesModal, toggleApproveModal } from 'project/ducks/wrapup';
import Bundles from 'project/components/wrapup/bundles';
import { getProject } from 'project/ducks/project';

const mapStateToProps = ({ user, project, admin }) => ({
  user: user.profile_data,
  project: user.profile_data.is_staff? admin.projects.currentProject : getProject({ project }),
  showingUploadModal: project.wrapup.showingBundlesModal,
  showingApproveModal: project.wrapup.showingApproveModal,
});

export default connect(mapStateToProps, {
  toggleUploadModal: toggleBundlesModal,
  toggleApproveModal,
})(Bundles);



// WEBPACK FOOTER //
// ./project/containers/wrapup/bundles.js